export const editorMenuTitleTestIds = {
  documentTitle: 'document-title',
};
